import { useEffect, useRef } from "react";
import { useSettings } from "../context/SettingsContext";

/**
 * Włącza nowy modal komunikatora w zależności od settinga
 */
export const useMessageThreadModal = () => {
  const isEnabled = useRef(false);
  const { settings } = useSettings();

  const newLookMessageThreadSettingValue =
    settings?.newLookSystemCommunicator ?? false;

  useEffect(
    function enableMessageThreadDialog() {
      if (newLookMessageThreadSettingValue && isEnabled.current === false) {
        isEnabled.current = true;

        const importMessageThreadAuraCompat = async () => {
          await import("../feature/communication/auraCompat");
        };

        importMessageThreadAuraCompat();
      }
    },
    [newLookMessageThreadSettingValue]
  );
};
